import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IimCardModule, IimDatepickerModule, IimDecimalInputV2Component } from '@iim-angular/components';
import { BasketSupplierItemFeatureModule } from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/feature';
import { TranslateModule } from '@ngx-translate/core';
import { TextModuleSelectionComponent } from '@lib/shared/text-module';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { AccountingSelectionModule } from '@lib/accounting';
import { SharedImageUiModule } from '@lib/shared/image/ui';
import { DisplayCurrencyModule, StringPreviewModule, SupplierDisplayNamePipe } from '@lib/util';
import { ReactiveFormsModule } from '@angular/forms';
import { ClassificationSelectionComponent } from '@lib/classification';
import { CopyToClipboardModule, FileDownloadModule } from '@lib/core';
import { BasketSupplierUiComponent } from './basket-suppliers-basket-basket-supplier-ui/basket-supplier-ui.component';
import { SourcingWaiverComponent } from './sourcing-waiver/sourcing-waiver.component';
import { DeliveryConditionsModule } from '@lib/delivery-conditions';
import { BasketSupplierPaymentTermComponent } from './basket-supplier-payment-term/basket-supplier-payment-term.component';
import { BasketSupplierFrameContractSelectionComponent } from './basket-supplier-frame-contract-selection/basket-supplier-frame-contract-selection.component';

@NgModule({
    imports: [
        SupplierDisplayNamePipe,
        CommonModule,
        TranslateModule,
        IimCardModule,
        TextModuleSelectionComponent,
        MatChipsModule,
        MatSelectModule,
        IimDecimalInputV2Component,
        AccountingSelectionModule,
        SharedImageUiModule,
        StringPreviewModule,
        ReactiveFormsModule,
        IimDatepickerModule,
        ClassificationSelectionComponent,
        CopyToClipboardModule,
        BasketSupplierItemFeatureModule,
        DeliveryConditionsModule,
        BasketSupplierPaymentTermComponent,
        BasketSupplierPaymentTermComponent,
        BasketSupplierFrameContractSelectionComponent,
        FileDownloadModule,
        DisplayCurrencyModule,
    ],
    declarations: [BasketSupplierUiComponent, SourcingWaiverComponent],
    exports: [BasketSupplierUiComponent, SourcingWaiverComponent],
})
export class SupplierBasketUiModule {}
